export default "__VITE_ASSET__BN3C0ZlX__"